import { isPlainDatatype } from '../../../datatype/Datatype.ts';
import { createConditionOperator } from '../IConditionOperator.ts';
import {
  getComparableNumbers,
  shouldCompareAsNumber,
} from '../utils/numericConditionCoerce.ts';

export const ConditionOperatorEqualsType = createConditionOperator({
  code: 'equals',
  label: '=',
  description: 'Uguale a',
  args: [{ type: 'referenceValue' }],
  allowsField: field => isPlainDatatype(field.type),
  compare(value: any, [target]: [any], scope, field) {
    if (value == null && target == null) return true;
    if (shouldCompareAsNumber(field, value, target)) {
      const numbers = getComparableNumbers(value, target);
      return numbers
        ? numbers.numericValue.equals(numbers.numericTarget)
        : value === target;
    }
    return value === target;
  },
});
